/**
 * Flags fixed when the bundle is built.
 *
 * Everything else in this app is configured at runtime, which is deliberate —
 * one set of built assets can be pointed anywhere. Native builds are the
 * exception: React Native has no environment to read and no page to inject
 * into, so these two have to be baked in. `MFA_DEMO=true` makes Babel resolve
 * `@mfa/build-flags` to `flags.demo` instead of this file.
 */

export const buildFlags = {
  demoMode: false,

  /**
   * API host compiled into native builds.
   *
   * The web build ignores this: it takes the host from the page, so one set
   * of web assets can be repointed without a rebuild. An APK cannot be
   * repointed, so it ships with the host it was built against: the charity's
   * own domain, where the server answers /api.
   *
   * Builds made before the move to that server have
   * https://meal-donater.vercel.app instead. That address must keep working:
   * the root vercel.json forwards its /api to this domain.
   */
  apiBaseUrl: 'https://meal4all.com' as string | null,
} as const;
